import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Chip, Text } from '@frontend/design-system';

type Props = {
  taskCount: number;
  onClick?: () => void;
};

const TaskChip = ({ taskCount, onClick }: Props) => {
  const { t } = useTranslation('calls');

  return (
    <Chip as='button' rightElement={<Icon name='caret-right-tiny' />} css={styles.chip} onClick={onClick}>
      <Text size='small' color='white' weight='bold'>
        {/* This conditional statement is there because pluralization is not working for translations */}
        {taskCount > 1 ? t('{{ taskCount }} Tasks', { taskCount }) : t('{{ taskCount }} Task', { taskCount })}
      </Text>
    </Chip>
  );
};

export default TaskChip;

const styles = {
  chip: css`
    background-color: ${theme.colors.tangerine40};
    border: 1px solid ${theme.colors.tangerine60};
    color: ${theme.colors.white};
    gap: ${theme.spacing(0.5)};
    cusrsor: pointer;
    &:hover {
      background-color: ${theme.colors.tangerine50};
    }

    @container (max-width: ${breakpoints.small.max}px) {
      font-size: ${theme.font.size.small};
      padding: ${theme.spacing(0.25, 0.5)};
      height: ${theme.spacing(2)};
      > svg {
        height: ${theme.spacing(1)};
      }
      &:focus {
        outline: none;
      }
    }
  `,
};
